import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {DetalhesProcesso} from "../models/detalhes-processo";
import {Pasta} from "../models/pasta";
import {NovaPasta} from "../models/nova-pasta";

@Injectable({
  providedIn: "root"
})
export class PastaService{
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`PastaService`);
  }

  baseUrl = environment.apiUrl;

  adicionar(request: NovaPasta): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .post<BaseResponse<DetalhesProcesso>>(`${this.baseUrl}/Pasta`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  buscarPorPessoaId(pessoaId: number): Observable<BaseResponse<Pasta[]> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<DetalhesProcesso>>(`${this.baseUrl}/Pasta/${pessoaId}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorPessoaId')));
  }
}
